import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Thriftlicious · Your Treasure Awaits</p>
        <h1>Discover Unique Finds at Thriftlicious</h1>
        <p className="lede">
          Explore our curated collection of second-hand clothing, accessories, and vintage items. 
          Each piece has a story, waiting for you to make it your own.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_self">
            Shop Now
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Eco-Friendly Fashion</h2>
          <p>
            Join us in promoting sustainable fashion. Every purchase helps reduce waste and supports a greener planet.
          </p>
        </article>
        <article>
          <h2>Curated Vintage Collection</h2>
          <p>
            From retro clothing to unique accessories, our vintage collection is handpicked for style and quality.
          </p>
        </article>
        <article>
          <h2>Affordable Style</h2>
          <p>
            Find stylish pieces at prices that won’t break the bank. Refresh your wardrobe without the guilt.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;